import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";

export enum StorageKeys {
    CurrentAuth = "currentAuth",
    Token = "token",
}

@Injectable({
    providedIn: "root"
})
export class LocalStorageService {

    private platformId = inject(PLATFORM_ID);
    private isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    public set(key: string, value: string): void {
        if (this.isBrowser()) {
            localStorage.setItem(key, value);
        }
    }

    public get(key: string): string | null {
        if (this.isBrowser()) {
            return localStorage.getItem(key);
        }
        return null;
    }

    public remove(key: string): void {
        if (this.isBrowser()) {
            localStorage.removeItem(key);
        }
    }
}
